module.exports = __webpack_public_path__ + "img/marketplace-icon.svg";